import { SocialButton } from 'components/SocialButton';
import { CmsApiPage } from 'modules/cms/api/types/CmsApiPage';

type Props = {
  content: CmsApiPage;
  message: string | null | undefined;
  title: string;
  subsite: string | undefined;
};

export function CmsSocialButtons({ content, message, title, subsite }: Props) {
  return (
    <>
      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="facebook"
        utmParams={{}}
        // @ts-expect-error TS(2769): No overload matches this call.
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      />

      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="twitter"
        utmParams={{}}
        // @ts-expect-error TS(2769): No overload matches this call.
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      />

      <SocialButton
        object={content}
        objectType="CMS_PAGE"
        socialType="linkedin"
        utmParams={{}}
        // @ts-expect-error TS(2769): No overload matches this call.
        message={message}
        eventName="Share post"
        eventProperties={{
          title,
          subsite,
        }}
      />
    </>
  );
}
